import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "ranking" }
const _hoisted_2 = { class: "title-box" }
const _hoisted_3 = { class: "table-box" }
const _hoisted_4 = { class: "rank-box" }
const _hoisted_5 = {
  key: 3,
  class: "rank-text"
}
const _hoisted_6 = { class: "user-name" }

import { ref, reactive,onMounted,watch,getCurrentInstance, ComponentInternalInstance, } from 'vue';
import { useStore } from 'vuex'
import { getUserLevelDetail } from '@/service';
import { $enum } from '@/global'
import Pagination from "@/config/pagination";
import { getSceneTypeTree, getScores, getRankingsScoresBySceneTypeAndTenantId } from '@/service'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  sceneId: {
    required: false,
    type: String,
    default: '',
  },

},
  setup(__props, { expose: __expose }) {

const props = __props;
const store = useStore();
const showModel = ref(false);
const sceneTypeId = ref<number>(2)
const state = reactive({
  trophyColumns :[
    {prop: 'rankIndex', label: '排名', width: '80',slotName: 'ranking'},
    {prop: 'userName', label: '用户',slotName: 'userName'},
    {prop: 'maxScore', label: '最高得分', slotName: 'maxScore'},
    {prop: 'qualified', label: '合格/总场次', slotName: 'qualified'},
    {prop: 'passRate', label: '合格率'},
    {prop: 'flyTime', label: '总时长', slotName: 'flyTime'},
  ],
  trophyData:[],
  pagination:new Pagination(),
})
const { proxy } = getCurrentInstance() as ComponentInternalInstance;

watch(showModel, (newVal, oldVal) => {
  if(newVal){
    getRankData();

  }
})
function handleClose() {
  window?.playClick();
  showModel.value = false;
}
function onSliceUsername(userName:any){
  return  userName && userName.length<=10 ? userName : (!userName?'': userName.slice(0,10)+'...')
}
function handleChangePage(val:any){
  state.pagination.pageNum = val;
  // initTableData()
}
function handleChangeSize(val:any){
  state.pagination.pageSize = val;
  state.pagination.pageNum = 1;
  // initTableData()
}
async function getRankData(){
  state.trophyData = [];
  // 后期修改 sceneId
  const {code,data} = await getRankingsScoresBySceneTypeAndTenantId({sceneTypeId:props.sceneId,tenantId:store.state.persistence.currentTenantId}) as any;
  if(code!= $enum.EnumResult.SUCCESS){
    proxy?.vknMessage.error("获取排行榜数据失败！");
    return;
  }
  if(data?.length>0){
    // data.forEach((item:any, index:number) => {
    //   item.index = index + 1;
    // })
    state.trophyData = data;
  }
}

// 格式化函数
const formatSeconds = (row:any) => {
  const seconds = row.flyTime;
  if (!seconds || isNaN(seconds)) return '--';
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${hours}h${minutes}min`;
};
__expose({ showModel })

return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_vke_table = _resolveComponent("vke-table")!
  const _component_vkm_modal = _resolveComponent("vkm-modal")!

  return _withDirectives((_openBlock(), _createBlock(_component_vkm_modal, {
    title: "排行榜",
    onOnClose: handleClose,
    isFooter: false
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "box-lft" }, [
            _createElementVNode("p", null, "排行榜"),
            _createElementVNode("p", null, "排名只显示前100名")
          ], -1)),
          _createVNode(_component_vkm_svg, {
            "icon-name": "jiangbei",
            class: "icon"
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_vke_table, {
            columns: state.trophyColumns,
            tableData: state.trophyData,
            "show-pagination": false,
            onPageChange: handleChangePage,
            onSizeChange: handleChangeSize
          }, {
            ranking: _withCtx(({scope}) => [
              _createElementVNode("div", _hoisted_4, [
                (scope.row.rankIndex == 1)
                  ? (_openBlock(), _createBlock(_component_vkm_svg, {
                      key: 0,
                      "icon-name": "rankNo1",
                      class: "icon"
                    }))
                  : (scope.row.rankIndex == 2)
                    ? (_openBlock(), _createBlock(_component_vkm_svg, {
                        key: 1,
                        "icon-name": "rankNo2",
                        class: "icon"
                      }))
                    : (scope.row.rankIndex == 3)
                      ? (_openBlock(), _createBlock(_component_vkm_svg, {
                          key: 2,
                          "icon-name": "rankNo3",
                          class: "icon"
                        }))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(scope.row.rankIndex), 1))
              ])
            ]),
            userName: _withCtx(({scope}) => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_vkm_svg, {
                  "icon-name": "jpfs",
                  class: "icon"
                }),
                _createElementVNode("p", null, _toDisplayString(onSliceUsername(scope.row.userName)), 1)
              ])
            ]),
            maxScore: _withCtx(({scope}) => [
              _createElementVNode("span", null, _toDisplayString(Number(scope.row.maxScore).toFixed(0)), 1)
            ]),
            qualified: _withCtx(({scope}) => [
              _createElementVNode("span", null, _toDisplayString(`${scope.row.passNum}/${scope.row.scoreNum}`), 1)
            ]),
            flyTime: _withCtx(({scope}) => [
              _createElementVNode("span", null, _toDisplayString(formatSeconds(scope.row)), 1)
            ]),
            _: 1
          }, 8, ["columns", "tableData"])
        ])
      ])
    ]),
    _: 1
  }, 512)), [
    [_vShow, showModel.value]
  ])
}
}

})